/**
 * The one place this app hardcodes the public marketing domain.
 *
 * The app's own API origin is not here: that is VITE_API_BASE_URL (see
 * src/api/client.ts), already a per-environment setting.
 */
export const MARKETING_ORIGIN = 'https://ezpark312.com';
